const text = require('./text.yaml')[templateVars.lang];
const config = require('./config.yaml');

module.exports = function () {
	return {
		id: 'tools--',
		steps: [{
			target: '.js-add-page',
			id: 'addToReport',
			placement: config.tourPlacement,
			title: text.addToReport,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.addToReportAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--myreport',
			id: 'myReport',
			placement: config.tourPlacement,
			title: text.myReport,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.myReportAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-print',
			id: 'printVersion',
			placement: config.tourPlacement,
			title: text.printVersion,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.printVersionAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-get-pdf',
			id: 'pdf',
			placement: config.tourPlacement,
			title: text.pdf,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.pdfAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-share',
			id: 'share',
			placement: config.tourPlacement,
			title: text.share,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.shareAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--history',
			id: 'history',
			placement: config.tourPlacement,
			title: text.history,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.historyAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-feedback-form-button',
			id: 'feedback',
			placement: config.tourPlacement,
			title: text.feedback,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.feedbackAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--download',
			id: 'download',
			placement: config.tourPlacement,
			title: text.download,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.downloadAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--analysis',
			id: 'analysis',
			placement: config.tourPlacement,
			title: text.analysis,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.analysisAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-compare',
			id: 'compare',
			placement: config.tourPlacement,
			title: text.compare,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `
				<div class="tour-compare-report__section">
					<span class="tour-compare-report__icon tour-compare-report__icon--compare"></span>
					<span class="tour-compare-report__text">
						(${text.compare}) - ${text.buttonCompareText}
					</span>
				</div>
				<div class="tour-compare-report__section">
					<span class="tour-compare-report__icon tour-compare-report__icon--see"></span>
					<span class="tour-compare-report__text">
						(${text.see}) - ${text.buttonSeeText}
					</span>
				</div>`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.js-compare',
			id: 'compare',
			placement: config.tourPlacement,
			title: text.compare,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `
				<div class="tour-compare-report__section">
					<span class="tour-compare-report__icon tour-compare-report__icon--compare"></span>
					<span class="tour-compare-report__text">
						(${text.compareList}) - ${text.listCompareText}
					</span>
				</div>
				<div class="tour-compare-report__section">
					<span class="tour-compare-report__icon tour-compare-report__icon--see"></span>
					<span class="tour-compare-report__text">
						(${text.seeList}) - ${text.listSeeText}
					</span>
				</div>
				<div class="tour-compare-report__section">
					<span class="tour-compare-report__icon tour-compare-report__icon--previous-reports"></span>
					<span class="tour-compare-report__text">
						(${text.previousReports}) - ${text.listPreviousReportsText}
					</span>
				</div>`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--offline',
			id: 'offline',
			placement: config.tourPlacement,
			title: text.offline,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.offlineAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--questionary',
			id: 'questionary',
			placement: config.tourPlacement,
			title: text.questionary,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.questionaryAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--social',
			id: 'social',
			placement: config.tourPlacement,
			title: text.social,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.socialAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--ios',
			id: 'ios',
			placement: config.tourPlacement,
			title: text.ios,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.iosAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--android',
			id: 'android',
			placement: config.tourPlacement,
			title: text.android,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.androidAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--mobile-app',
			id: 'mobileApp',
			placement: config.tourPlacement,
			title: text.mobileApp,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.mobileAppAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--on-map',
			id: 'companyOnMap',
			placement: config.tourPlacement,
			title: text.companyOnMap,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.companyOnMapAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--site-map',
			id: 'siteMap',
			placement: config.tourPlacement,
			title: text.siteMap,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.siteMapAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--contacts',
			id: 'contacts',
			placement: config.tourPlacement,
			title: text.contacts,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.contactsAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--xls',
			id: 'xls',
			placement: config.tourPlacement,
			title: text.xls,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.xlsAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--glossary',
			id: 'glossary',
			placement: config.tourPlacement,
			title: text.glossary,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.glossaryAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--disclaimer',
			id: 'disclaimer',
			placement: config.tourPlacement,
			title: text.disclaimer,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.disclaimerAbout}`,
			showNextButton: true,
			showPrevButton: true
		}, {
			target: '.buttons-panel__link--archive-reports',
			id: 'archive',
			placement: config.tourPlacement,
			title: text.archive,
			width: config.tourWidth,
			xOffset: config.tourXOffset,
			yOffset: config.tourYOffset,
			content: `${text.archiveAbout}`,
			showNextButton: true,
			showPrevButton: true
		}]
	};
};



// WEBPACK FOOTER //
// ./temp/components/buttons-panel/tourConfig.js